import { useCallback } from "react";
import { useAppDispatch, useAppSelector } from "hooks/reduxHooks";
import {
  changeSortOfClinicList,
  changeSortOfClinicianPatientsList,
  goToPageClinicianPatients,
  goToPageClinicians,
} from "store/ClinicianStore/actions";
import {
  selectCurrentClinician,
  selectSortConfig,
  selectSortConfigClinicianPatients,
  selectCurrentClinicianLoading,
  selectCurrentClinicianPatientsLoading,
  selectCliniciansCurrentPage,
  selectCliniciansTotalPages,
  selectClinicianPatientsCurrentPage,
  selectClinicianPatientsTotalPages,
} from "store/ClinicianStore/selectors";
import { USER_GROUPS } from "constants/roles";
import { ManagementType } from "types/common";
import { ContainerForCliniciansOtherRoles } from "./ContainerForCliniciansOtherRoles";
import {
  selectLoading,
  selectSortConfigClinicPatients,
  selectClinicPatientsCurrentPage,
  selectClinicPatientsTotalPages,
} from "store/PatientStore/selectors";
import {
  changeSortOfClinicPatientsList,
  goToPageClinicPatients,
} from "store/PatientStore/actions";
import { Clinician } from "types/Clinician";

type Props = {
  managementType?: ManagementType;
};

export const UserListContaier = ({ managementType }: Props) => {
  const dispatch = useAppDispatch();
  const currentClinician: Clinician | undefined = useAppSelector(
    selectCurrentClinician
  );
  const sortConfig = useAppSelector(selectSortConfig);
  const sortConfigClinicianPatients = useAppSelector(
    selectSortConfigClinicianPatients
  );
  const sortConfigClinicPatients = useAppSelector(
    selectSortConfigClinicPatients
  );
  const clinicianPatientsLoading = useAppSelector(
    selectCurrentClinicianLoading
  );
  const clinicianPatientsIsLoading = useAppSelector(
    selectCurrentClinicianPatientsLoading
  );
  const clinicPatientsLoading = useAppSelector(selectLoading);

  const usersPage = useAppSelector(selectCliniciansCurrentPage);
  const usersTotalPages = useAppSelector(selectCliniciansTotalPages);
  const clinicPatientsPage = useAppSelector(selectClinicPatientsCurrentPage);
  const clinicPatientsTotalPages = useAppSelector(selectClinicPatientsTotalPages);
  const clinicianPatientsPage = useAppSelector(selectClinicianPatientsCurrentPage);
  const clinicianPatientsTotalPages = useAppSelector(selectClinicianPatientsTotalPages);

  const onUsersPageChange = useCallback(
    (_ev: React.ChangeEvent<unknown>, page: number) => {
      dispatch(goToPageClinicians(page));
    },
    [dispatch]
  );

  const onClinicPatientsPageChange = useCallback(
    (_ev: React.ChangeEvent<unknown>, page: number) => {
      dispatch(goToPageClinicPatients(page));
    },
    [dispatch]
  );

  const onClinicianPatientsPageChange = useCallback(
    (_ev: React.ChangeEvent<unknown>, page: number) => {
      if (currentClinician) {
        dispatch(goToPageClinicianPatients(currentClinician._id ?? "", page));
      }
    },
    [currentClinician, dispatch]
  );

  const onClick = (sortBy: string) => {
    if (sortBy != "sport") {
      dispatch(changeSortOfClinicList(sortBy));
    }
  };

  const onClickClinicianPatients = (sortBy: string) => {
    if (sortBy != "sport") {
      dispatch(changeSortOfClinicianPatientsList(sortBy));
    }
  };

  const onClickClinicPatients = (sortBy: string) => {
    if (sortBy != "sport") {
      dispatch(changeSortOfClinicPatientsList(sortBy));
    }
  };

  const getSortConfig = () => {
    if (managementType === ManagementType.PATIENT_CARE) {
      return sortConfigClinicianPatients;
    } else if (managementType === ManagementType.PATIENT) {
      return sortConfigClinicPatients;
    } else {
      return sortConfig;
    }
  };

  return (
    <div className="mt-6 flex flex-col white-space-nowrap pb-16">
      {(currentClinician?.role?.includes(USER_GROUPS.CLINIC_ADMIN) ||
        currentClinician?.role?.includes(USER_GROUPS.CLINIC_ASSISTANT) ||
        currentClinician?.role?.includes(USER_GROUPS.CLINIC_TEAM_LEAD) ||
        currentClinician?.role?.includes(USER_GROUPS.CLINICIAN) ||
        currentClinician?.role?.includes(USER_GROUPS.CLINIC_TEAM_MEMBER)) && (
        <ContainerForCliniciansOtherRoles
          managementType={managementType}
          currentClinician={currentClinician}
          sortConfig={getSortConfig()}
          onClick={onClick}
          clinicianPatientsLoading={
            clinicianPatientsLoading || clinicianPatientsIsLoading
          }
          clinicPatientsLoading={clinicPatientsLoading}
          onClickClinicianPatients={onClickClinicianPatients}
          onClickClinicPatients={onClickClinicPatients}
          clinicPatientsPage={clinicPatientsPage}
          clinicPatientsTotalPages={clinicPatientsTotalPages}
          onClinicPatientsPageChange={onClinicPatientsPageChange}
          clinicianPatientsPage={clinicianPatientsPage}
          clinicianPatientsTotalPages={clinicianPatientsTotalPages}
          onClinicianPatientsPageChange={onClinicianPatientsPageChange}
          usersPage={usersPage}
          usersTotalPages={usersTotalPages}
          onUsersPageChange={onUsersPageChange}
        />
      )}
    </div>
  );
};
